// Third-party
import React from 'react';
import classNames from 'classnames';

// Components
import NoDataCell from './NoDataCell';

// Utils
import { isBenchmark } from '../../../utils/comparison';
import { BenchmarkViewer, BenchmarkToggler } from '../misc';
import ComparisonItem from '@/types/comparison-item';

type Props = {
  activeBenchmark?: ComparisonItem;
  className?: string;
  onClick?: () => void;
  linkDisabled: boolean;
  id?: string;
  item: ComparisonItem;
  disabled?: boolean;
};

const BenchmarkCell: React.FunctionComponent<Props> = (props: Props) => {
  const { activeBenchmark, className, onClick, id, item, linkDisabled, disabled } = props;
  const hasRiskFree = !!item.benchmarks && !!item.benchmarks.riskFree;
  const hasMarket = !!item.benchmarks && !!item.benchmarks.market;

  if (isBenchmark(item)) {
    return <BenchmarkToggler item={item} disabled={disabled} />;
  }
  if (!hasRiskFree && !hasMarket) {
    return <NoDataCell onClick={onClick} id={id} />;
  }

  return (
    <div className={classNames(className, 'cell benchmark-cell')} onClick={onClick} id={id ? `cell-${id}` : undefined}>
      <BenchmarkViewer activeBenchmark={activeBenchmark} item={item} linkDisabled={linkDisabled} />
    </div>
  );
};

export default BenchmarkCell;
